import React from "react";

import cx from "classnames";

import styles from "./TextTransform.scss";

export interface TextTransformProps {
  /** Inner Text/Node */
  text?: React.ReactNode;
  /** Type of the transformation */
  type:
    | "default"
    | "lowercase"
    | "uppercase"
    | "capitalize"
    | "capitalize-first-letter";
  /** The text displays in one line */
  nowrap?: boolean;
}

/**
 * A component that styles the text with the css property `text-transform`. Renders
 * children if provided, otherwise renders the `text` prop.
 */
export function TextTransform({
  children,
  text,
  type,
  nowrap,
}: React.PropsWithChildren<TextTransformProps>) {
  const className = cx(styles.text, {
    [styles["text--capitalize-first-letter"]]:
      type === "capitalize-first-letter",
    [styles["text--lowercase"]]: type === "lowercase",
    [styles["text--uppercase"]]: type === "uppercase",
    [styles["text--capitalize"]]: type === "capitalize",
    [styles["text--nowrap"]]: nowrap,
  });

  return (
    <span data-testid="text-transform-span" className={className}>
      {children || text}
    </span>
  );
}
